function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: ", ";\n  background-image: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
export var AppIconStyle = styled.div(_templateObject(), function (props) {
  return props.theme.variables.icons.size[props.size || 'extraLarge'];
}, function (props) {
  return props.theme.variables.icons.size[props.size || 'extraLarge'];
}, function (props) {
  return !!props.onClick ? 'pointer' : 'default';
}, function (props) {
  return "url(\"".concat(props.theme.variables.icons.svg[props.icon], "\")");
});